"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompatibleFilterTypes = exports.isFilterColumnType = exports.COMPATIBLE_FILTER_TYPES = void 0;
exports.COMPATIBLE_FILTER_TYPES = {
    string: ["string", "stringOptions"],
    stringOptions: ["string", "stringOptions"],
    arrayOptions: ["arrayOptions", "stringOptions"],
    datetime: ["datetime"],
    number: ["number"],
    boolean: ["boolean"],
    stringObject: ["stringObject"],
    numberObject: ["numberObject"],
    booleanObject: ["booleanObject"],
    categoryOptions: ["categoryOptions", "stringOptions"],
};
const FILTER_COLUMN_TYPES_WITHOUT_COMPATIBLE_FILTERS = [
    "null",
    "positionInTrace",
];
const isFilterColumnType = (type) => typeof type === "string" &&
    (Object.hasOwn(exports.COMPATIBLE_FILTER_TYPES, type) ||
        FILTER_COLUMN_TYPES_WITHOUT_COMPATIBLE_FILTERS.some((filterColumnType) => filterColumnType === type));
exports.isFilterColumnType = isFilterColumnType;
const getCompatibleFilterTypes = (columnType) => exports.COMPATIBLE_FILTER_TYPES[columnType] ?? null;
exports.getCompatibleFilterTypes = getCompatibleFilterTypes;
